(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbContentTypesDataStore', ['$q', 'smbContentTypesService', ContentTypesDataStore]);
	
	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesDataStore
	 * 
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function ContentTypesDataStore($q, smbContentTypesService) {
		var _groupId;
		var _contentTypes;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypesDataStore.contentTypes
			 * @propertyOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * All content types that belong to the current content type group.
			 */
			get contentTypes() {
				return _contentTypes;
			},

			/**
			 * @ngdoc method
			 * @name smbContentTypesDataStore.getContentTypes
			 * @methodOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * Loads and returns all content types for a specific content type group by group id.
			 * 
			 * @param {Number} groupId The content type group id
			 * 
			 * @returns {Deferred} A promise that resolves to a collection of content types.
			 */
			getContentTypes: getContentTypes,
			/**
			 * @ngdoc method
			 * @name smbContentTypesDataStore.deleteContentType
			 * @methodOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * Deletes a document type with the specified ID.
			 * 
			 * @param {Number} typeId The document type id
			 * 
			 * @returns {Deferred} A promise that will resolve if the deletion was successful.
			 */
			deleteContentType: deleteContentType
		};	

		function getContentTypes(groupId) {
			if (!groupId) {
				return $q.resolve(_contentTypes);
			} else {
				return smbContentTypesService.getContentTypes(groupId)
					.then(function (types) {
						_contentTypes = types;
						_groupId = groupId;
						return types;
					});
			}
		}

		function deleteContentType(typeId, purge){
			if (!typeId) {
				return $q.resolve(new Error('No type ID provided.'));
			} else {
				return smbContentTypesService
					.deleteContentType(typeId, purge)
					.then(function(){
						_contentTypes = _contentTypes.filter(function(contentType){
							return contentType.FolderId !== typeId;
						});
					});
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentTypesDataStore.js
// module id = 115
// module chunks = 1